import CTNChart from '@ctn/ui/components/ctn-chart';
import { type ChartData } from 'chart.js';
import classNames from 'classnames';
import React, { useMemo } from 'react';

import { customGenerateStackedConfig } from '@/helpers/charts';

import { classNameCharts, classNameTemplate } from './config';

const classNameComponent = `${classNameCharts}`;

const CardChartStackedTemplate = ({
	className,
	classNameChart,
	data,
	total,
	title,
}: {
	readonly className?: string;
	readonly classNameChart?: string;
	readonly data?: Array<{ data: ChartData<'bar'>; label: string }>;
	readonly total?: number;
	readonly title: string | React.ReactElement;
}) => {
	const classNameStacked = useMemo(() => classNames(classNameComponent, classNameTemplate, className), [className]);
	const classNameCTNChart = useMemo(() => classNames('u-mt-8', classNameChart), [classNameChart]);

	return (
		<div className={classNameStacked}>
			<h4 className="t-ctn-card-chart__tit">{title}</h4>
			<ul className="[ c-pnp-chart-stacked ] [ u-flow ]">
				{total && data?.map(({ data, label }) => (
					<li key={label} className="c-pnp-chart-stacked__item">
						<p className="c-pnp-chart-stacked__tit c-pnp-heading-h5">{label}</p>
						<CTNChart className={classNameCTNChart} config={customGenerateStackedConfig(data, total)} />
					</li>
				))}
			</ul>

		</div>
	);
};

export default CardChartStackedTemplate;
